export const API_URL = `${process.env.REACT_APP_API_URL}/api/v1`

export const ROUTES = {
  dashboard: '/',
  food: '/food',
  notFound: '/not-found',
  packaging: '/food/package-pieces',
  piece: '/food/package-pieces/piece',
  transportActivity: '/food/transport-activity',
  transport: '/food/transport-activity/transport',
  saleActivity: '/food/sale-activity',
  sale: '/food/sale-activity/sale',
  resourcesSources: '/resource-country-impacts',
  resourcesSourcesReadonly: '/resources-sources-readonly',
  resource: '/resource-country-impacts/resource',
  storageActivity: '/food/storage-activity',
  storage: '/food/storage-activity/storage',
  processingActivity: '/food/processing-activity',
  processing: '/food/processing-activity/process',
  emissionFactors: '/food/emission-factors',
  emission: '/food/emission-factors/factor',
  generics: '/food/generics',
  generic: '/food/generics/generic',
  processedIngredients: '/food/processed-ingredients',
  processedIngredient: '/food/processed-ingredients/ingredient',
  specialIngredients: '/food/special-ingredients',
  specialIngredient: '/food/special-ingredients/ingredient',
  produce: '/food/produce',
  product: '/food/product',
  productGpc: '/food/product/gpc',
  produceIngredient: '/food/produce/ingredient',
  waterScarcity: '/water-scarcity',
  resources: '/resources',
  sources: '/sources',
  componentTaxonomyItem: '/packaging/components/component',
  materialTaxonomy: '/packaging/materials',
  componentTaxonomy: '/packaging/components',
  materialEmissionFactors: '/packaging/emission-factors',
  materialEmissionFactorsItem: '/packaging/emission-factors/factor',
  packagingProcessing: '/packaging/processing',
  packagingProcessingItem: '/packaging/processing/process',
  endOfLife: '/packaging/end-of-life',
  endOfLifeItem: '/packaging/end-of-life/item',
  // Packaging PCF - Material Taxonomies
  materialTaxonomies: '/packaging/material-taxonomies',
  materialTaxonomyDetail: '/packaging/material-taxonomies/material-taxonomy',
}

export enum ActivityTypes {
  EmissionFactors = 'EmissionFactors',
  PackagingPiece = 'PackagingPiece',
  ProcessingActivity = 'ProcessingActivity',
  PackagingProcessingActivity = 'PackagingProcessingActivity',
  ProcessedIngredient = 'Taxonomy/ProcessedIngredient/functionalUnit',
  ProduceIngredient = 'Taxonomy/Produce/functionalUnit',
  ProductGPC = 'Taxonomy/Product/brick',
  ResourceSources = 'ResourceSourceImpacts',
  SalesActivity = 'SalesActivity',
  SpecialIngredient = 'Taxonomy/SpecialIngredient/functionalUnit',
  StorageActivity = 'StorageActivity',
  TransportActivity = 'TransportActivity',
  Generics = 'Generics',
  MaterialTaxonomy = 'Taxonomy/PackagingMaterials/functionalUnit',
  ComponentTaxonomy = 'Taxonomy/PackagingComponent/component',
  PackagingEmissionFactors = 'PackagingEmissionFactors',
  EndOfLife = 'EndOfLife',
}

export const EXPORT_MAX_ROW_COUNT = 1000000

export const RELEASE_FEATURE_FLAGS = {
  ENABLE_GLACIER: 'ENABLE_GLACIER',
}
